import { v4 } from 'uuid';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { notificationInitialState } from './notification.constant';
import { NotificationAction } from './notification.action';
import { getDefaultAutoHideDuration } from './_helpers/getDefaultAutoHideDuration';

export const notificationReducer = reducerWithInitialState(notificationInitialState)
  .case(NotificationAction.show, (state, payload) => {
    const { notificationKey, autoHideDuration, ...notificationProps } = payload;
    if (notificationKey && state.queue.some((n) => n.notificationKey === notificationKey)) {
      // deduplicate by key
      return state;
    }

    return {
      ...state,
      queue: [
        ...state.queue,
        {
          ...notificationProps,
          notificationKey: notificationKey ?? v4(),
          autoHideDuration: autoHideDuration ?? getDefaultAutoHideDuration(payload.severity),
          open: true,
        },
      ],
    };
  })
  .case(NotificationAction.close, (state, payload) => {
    const { key } = payload;

    return {
      ...state,
      queue: state.queue.filter((n) => n.notificationKey !== key),
    };
  })
  .case(NotificationAction.destroy, () => {
    return notificationInitialState;
  });
